// Coerce potential bigint values to numbers for calculations/animations
export const BigIntToNumber = (
  v: number | bigint | undefined | null,
): number => (typeof v === "bigint" ? Number(v) : Number(v ?? 0));
